var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('Field',{key:"field",attrs:{"name":_vm.field.name,"schema":{
    type: _vm.field.type,
    label: _vm.schema.label,
    fieldOptions: _vm.field.options
  },"environment-variables":_vm.environmentVariables},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}}):_c('div',{staticStyle:{"height":"100%","display":"flex"}},[_c('span',{key:"noField",staticStyle:{"margin-top":"auto","margin-bottom":"5px"},attrs:{"id":"primero"}},[_vm._v("(Selecciona una colección y campo)")])])}
var staticRenderFns = []

export { render, staticRenderFns }